import React, { useState } from 'react';
import {
    Grid,
    Typography,
} from '@material-ui/core';
import DetailNumber from "views/Widgets/FichaPaciente/detailNumber";
import {
    ArrowForward,
} from "@material-ui/icons/";
import { ButtonTextMUI as Button } from "utils/componentsStyle";
import {
    green, indigo,
} from "@material-ui/core/colors";
import ModalDialog from "views/Widgets/Common/ModalDialog";

export default function ModalEditLineaPrefactura({
    open,
    handleClose,
    linea,
    onGuardar,
}) {
    const [cantidad, setcantidad] = useState(linea.cantidad_efectuada_modificado);
    const [valor, setvalor] = useState(linea.valor_unitario_modificado);

    const handleOnChangeCantidad = (valorArg) => {
        const tempValor = isNaN(valorArg) ? 0 : valorArg;
        setcantidad(tempValor);
    };

    const handleOnChangeValor = (valorArg) => {
        const tempValor = isNaN(valorArg) ? 0 : valorArg;
        setvalor(tempValor);
    };

    const handleGuardar = () => {
        onGuardar(cantidad, valor);
        handleClose();
    };

    const listItem = [
        {
            labelInitial: "Cantidad original",
            initialValue: linea.cantidad_efectuada_inicial,
            labelModify: "Cantidad a facturar",
            modifyValue: cantidad,
            onChangeModify: e => handleOnChangeCantidad(parseInt(e.target.value.split('$').join('').split(',').join(''))),
        },
        {
            labelInitial: "Valor original",
            initialValue: linea.valor_unitario_inicial,
            labelModify: "Valor a facturar",
            modifyValue: valor,
            onChangeModify: e => handleOnChangeValor(parseInt(e.target.value.split('$').join('').split(',').join(''))),
            prefix: "$",
        },
    ];

    const _content_ = <div>
        <Grid
            container
            direction="row"
            justify="center"
            alignItems="center"
            item
            xs={12}
        >
            <Grid
                container
                direction="row"
                justify="center"
                alignItems="flex-start"
                item
                xs={12}
                style={{ margin: "10px 0" }}
            >
                <Grid item xs={6}>
                    <Typography variant="body2" gutterBottom>{`Código: ${linea.codigo_prestacion}`}</Typography>
                </Grid>
                <Grid item xs={6}>
                    <Typography variant="body2" gutterBottom>{`Prestación: ${linea.prestacion_efectuada}`}</Typography>
                </Grid>
            </Grid>
            {listItem.map((item) => (
                <Grid
                    container
                    direction="row"
                    justify="center"
                    alignItems="center"
                    item
                    xs={12}
                    style={{ margin: "10px 0" }}
                    key={item.labelModify}
                >
                    <Grid item xs={5} style={{ margin: "10px 0" }}>
                        <DetailNumber
                            isdisabled={true}
                            label={item.labelInitial}
                            value={item.initialValue}
                            thousandSeparator={true}
                            prefix={item.prefix || ""}
                        />
                    </Grid>
                    <Grid item xs={2} style={{ margin: "10px 0" }}>
                        <ArrowForward style={{ color: indigo[500] }} />
                    </Grid>
                    <Grid item xs={5} style={{ margin: "10px 0" }}>
                        <DetailNumber
                            label={item.labelModify}
                            value={item.modifyValue}
                            onchange={e => item.onChangeModify(e)}
                            thousandSeparator={true}
                            prefix={item.prefix || ""}
                        />
                    </Grid>
                </Grid>
            ))}
        </Grid>
    </div>;

    const _actions_ = <>
        {(cantidad !== "" && valor !== "" && valor >= 0) ?
            <Button
                mr={2}
                variant="contained"
                className="text-white"
                style={{ backgroundColor: green[500] }}
                onClick={handleGuardar}
            >
                Guardar
            </Button> :
            <Button
                disabled
                mr={2}
                variant="contained"
                className="text-white"
            >
                Guardar
            </Button>
        }
        <Button
            mr={2}
            variant="contained"
            className="text-white"
            color="primary"
            onClick={handleClose}
        >
            Cerrar
        </Button>
    </>;

    return (
        <ModalDialog
            open={open}
            onClose={handleClose}
            title="Editar prestación a facturar"
            _content_={_content_}
            _actions_={_actions_}
            maxWidth="sm"
        />
    );
}
